module.exports = __webpack_public_path__ + "static/img/referrer2.3bb868a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/referrer2.png
// module id = y2pu
// module chunks = 1